import request from '../../utils/request'
const urlParams = process.env.VUE_APP_UPLOAD_REAL_PATH
export default {
  //获取导出临时授权code,有效期5秒
  getExportCode(data) {
    const params = data
    return request({
      url: urlParams + '/verification/getExportCode',
      type: 'get',
      params: params
    })
  },
  // 获取用户列表
  getUserList(data) {
    const params = data
    return request({
      url: urlParams + '/userBackstage/list',
      type: 'get',
      params: params
    })
  },
  // 新增用户
  addUserInfo(data) {
    const params = data
    return request({
      url: urlParams + '/userBackstage/save',
      type: 'post',
      params: params
    })
  },
  // 用户信息修改
  updataUser( data ) {
    const params = data
    return request({
      url: urlParams + '/userBackstage/update',
      type: 'post',
      params: params
    })
  },
  //  更改用户状态
  upUserState(data) {
    const params = data
    return request({
      url: urlParams + '/userBackstage/updateStatus',
      type: 'get',
      params: params
    })
  },
  //  更改用户解锁 上锁
  updateLockStates(data) {
    const params = data
    return request({
      url: urlParams + '/userBackstage/updateLockStates',
      type: 'get',
      params: params
    })
  },  
  // 删除用户   
  delUser( data ) {
    const params = data
    return request({
      url: urlParams + '/userBackstage/del',
      type: 'get',
      params: params
    })
  },
  // 重置密码 
  resetPsw( data ) {
    const params = data
    return request({
      url: urlParams + '/userBackstage/resetPassWord',
      type: 'get',
      params: params
    })
  } , 
  // 修改密码
  updatePassWord( data ) {
    const params = data
    return request({
      url: urlParams + '/userBackstage/updateLoginPassWord',
      type: 'get',
      params: params
    })
  },  
  // 退出登录
  userBackstageLayout( data ) {
    const params = data
    return request({
      url: urlParams + '/userBackstage/layout',
      type: 'post',
      params: params
    })
  },    
}